/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-04 11:13:25
 * @LastEditors: jikeychang@gmail.com
 * @LastEditTime: 2021-03-04 11:14:22
 * @Description: FileDescription
 */

import db from './dbWeb';

const model = {
  /**
   * 预算部门
   */

  // 获取组织树
  getDepartmentTree(param) {
    return db.get('/department/tree', param);
  },
  // 获取组织详情
  getDepartmentDetail(param) {
    // 真实
    return db.get('/department/detail', param);
  },
  // 获取已删除部门
  getDeleteDepartments(param) {
    // 真实
    return db.post('/department/listDeleted', param);
  },
  // 新增加部门
  createDepartment(param) {
    // 真实
    return db.post('/department/create', param);
  },
  // 编辑组织信息
  editDepartment(param) {
    // 真实
    return db.post('/department/update', param);
  },
  // 停用部门
  deleteDepartment(param) {
    return db.get('/department/delete', param);
  },
  /* 用户远程搜索 */
  getRoleSources(param) {
    return db.post('/user/search', param);
  },
};

export default model;
